export default 'DD.MM.YYYY hh:mm:ss Z'
